import type { ObjectBounds } from '@/lib/guides/types/object-bounds'

export function edgesOf(b: ObjectBounds) {
  return {
    left: b.x,
    right: b.x + b.width,
    top: b.y,
    bottom: b.y + b.height,
    centerX: b.x + b.width / 2,
    centerY: b.y + b.height / 2,
  }
}
